import './App.css';
import { Routes, Route } from 'react-router-dom'
import Home from './Screen/Home/Home';
import Header from './Components/Header/Header';
import Footer from './Components/Footer/Footer';
import Loaders from './Components/Loader/Loader';
function App() {
  return (
    <div>
      <Header />
      <Routes>
        <Route path='/' element={<Home />} />
      </Routes>
      <Footer />
      <Loaders />
    </div>
  );
}

export default App;
